import { invoke } from '@shared/easyfy.decorators';
import { addCss, removeCss } from '@shared/easyfy.utils';
import { globalEvent } from '@shared/easyfy.core';

@invoke
export default class Menu {
  static Instance: Menu;
  private activeMenu: HTMLElement = document.querySelector('.mm-active .nav-list');
  private navHeader: HTMLElement = document.querySelector('.mm-active .nav-header');

  constructor() {
    Menu.Instance = this;
  }

  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'toggle-menu-children',
          callback: this.toggleMenuChildren,
        },
        {
          event: 'menu-goback',
          callback: this.menuGoBack,
        },
        {
          event: 'scroll-main-nav',
          callback: this.scrollMainNav,
        },
      ],
    });

    this.updateMenuStyle();
  }

  private updateMenuStyle() {
    const navList = document.querySelector('[data-container="nav-list"]') as HTMLElement;
    const navItems = document.querySelectorAll('.menu-item.level-1');
    const LINE_BREAK_CLASS_NAME = 'line-break';
    let updated = false;
    navItems?.forEach((navItem) => {
      var itemEl = navItem as HTMLElement;
      if (!updated && itemEl.offsetTop > navList.offsetTop) {
        navItem.classList.add(LINE_BREAK_CLASS_NAME);
        updated = true;
      }
    });
  }

  private scrollMainNav = (e) => {
    var element = e.target as HTMLElement;

    if (!element.hasAttribute('data-target')) element = element.parentElement;

    const scrollNumber: number = 200;
    const target = element.attributes['data-target']?.value;
    const direction = element.attributes['data-scroll-direction']?.value;
    const container = document.querySelector(`[data-container="${target}"`);
    const scrollRight = direction == 'right';

    const leftArrow: HTMLElement = document.querySelector('[data-event="scroll-main-nav"][data-scroll-direction="left"]');
    const rightArrow: HTMLElement = document.querySelector('[data-event="scroll-main-nav"][data-scroll-direction="right"]');

    var scroll: number = scrollRight ? scrollNumber : -scrollNumber;
    var scrollPosition: number = container.scrollLeft + scroll;
    const scrollWidth: number = container.scrollWidth;
    const leftToScroll: number = scrollWidth - (scrollPosition + container.clientWidth);

    const VISIBLE_CLASS_NAME = 'visible';

    if (scrollRight && leftToScroll < scroll) {
      scroll += leftToScroll;
      scrollPosition += leftToScroll;
    } else if (!scrollRight && scrollPosition < leftToScroll) {
      scroll -= leftToScroll;
      scrollPosition -= leftToScroll;
    }

    container.scrollBy({
      left: scroll,
      behavior: 'smooth',
    });

    if (scrollPosition <= 0) {
      removeCss(leftArrow, VISIBLE_CLASS_NAME);
    } else {
      addCss(leftArrow, VISIBLE_CLASS_NAME);
    }

    if (scrollWidth <= scrollPosition + container.clientWidth) {
      removeCss(rightArrow, VISIBLE_CLASS_NAME);
    } else {
      addCss(rightArrow, VISIBLE_CLASS_NAME);
    }

    return false;
  };

  private toggleMenuChildren = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const element = e.target as HTMLElement;

    if (element.dataset.target != null) {
      Menu.addBreadCrumbMenuItem(element.innerText);

      const childElement = document.querySelector(`[data-container="${element.dataset.target}"`);

      if (childElement) {
        Menu.updateMenuBreadcrumbs();

        const activeElement = document.querySelector('.mm-active');
        removeCss(activeElement, 'mm-active');
        addCss(activeElement, 'mm-visited');
        addCss(childElement, 'mm-active');

        this.registerMenuScroll();
      }
    }
  };

  private menuGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const element = e.target as HTMLElement;
    const container = element?.closest('.mm-active');
    const parent = element?.closest('.mm-visited');

    if (container) {
      removeCss(container, 'mm-active');
      Menu.removeBreadCrumbLastMenuItem();
      Menu.updateMenuBreadcrumbs();
    }

    if (parent) {
      removeCss(parent, 'mm-visited');
      addCss(parent, 'mm-active');
    }
  };

  private registerMenuScroll() {
    // unregister event scroll
    this.activeMenu?.removeEventListener('scroll', this.determineShadowLocation);

    // get active menu element
    this.activeMenu = document.querySelector('.mm-active .nav-list');
    this.navHeader = document.querySelector('.mm-active .nav-header');

    if (!this.activeMenu || !this.navHeader) return;

    const height = window.innerHeight - this.navHeader.offsetHeight;

    //no scroll needed
    if (this.activeMenu.scrollHeight <= height) return;

    this.activeMenu.style.setProperty('--header-height', `${this.navHeader.offsetHeight}px`);

    this.activeMenu.addEventListener('scroll', this.determineShadowLocation.bind(this), { passive: true });
    this.determineShadowLocation();
  }

  private determineShadowLocation = () => {
    if (this.activeMenu.scrollHeight - this.activeMenu.scrollTop < this.activeMenu.clientHeight + 10) {
      //scrolled all the way down
      removeCss(this.activeMenu, 'bottom');
    } else if (this.activeMenu.scrollTop > 0) {
      //scrolling
      addCss(this.activeMenu, ['bottom', 'top']);
    } else {
      //scrolled all the way up
      removeCss(this.activeMenu, 'top');
    }
  };

  private savedBreadcrumbsList: string[] = [];

  public static updateMenuBreadcrumbs = () => {
    const breadcrumbContainers = document.querySelectorAll('[data-container="menu-breadcrumbs"]');

    breadcrumbContainers?.forEach((el) => {
      el.innerHTML = '';
      Menu.Instance.savedBreadcrumbsList.forEach((menuItem, index) => {
        const isLast = index === Menu.Instance.savedBreadcrumbsList.length - 1;
        const spanElement = document.createElement('span');

        spanElement.textContent = menuItem;

        if (!isLast) {
          const chevronElement = document.createElement('i');
          chevronElement.className = 'icon icon-chevron-right size-xs clr-arrow';
          el.appendChild(spanElement);
          el.appendChild(chevronElement);
        } else {
          el.appendChild(spanElement);
        }
      });
    });
  };

  public static addBreadCrumbMenuItem = (menu: string) => {
    Menu.Instance.savedBreadcrumbsList.push(menu);
  };

  public static removeBreadCrumbLastMenuItem = () => {
    if (Menu.Instance.savedBreadcrumbsList.length > 0) Menu.Instance.savedBreadcrumbsList.pop();
  };
}
